import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Paper,
    Grid,
    FormControl,
    Select,
    MenuItem,
    TextField,
} from '@material-ui/core';

//Components
import DoughnutChart from './DoughnutChart';
import RotatedBarChart from './RotatedBarChart';
import LineChart from './LineChart';

import { SmallFormContainer } from './../shared/SmallFormContainer';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    select: {
        minWidth: '100%',
    },
    dividerButton: {
        borderTop: '1px solid #ddd',
        marginTop: '20px'
    },
    dividerTop: {
        borderTop: '1px solid #ddd',
        paddingTop: '20px',
        marginTop: '20px'
    },
    formContainer: {
        padding: '10px',
    },
    textField: {
        minWidth: '100%',
    },
    menuPaper: {
        maxHeight: '150px'
    }
});


class StatisticheLicenzeCmp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected_user: '',
        };

        this.onSelectChange = this.onSelectChange.bind(this);
    }

    componentDidMount() {
        if (this.props.codiceUtente !== 'anonymous') {
            this.setState({
                selected_user: this.props.codiceUtente,
            });
        }
    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.codiceUtente !== propsPrecedenti.codiceUtente) {

            if (this.props.codiceUtente !== 'anonymous') {
                this.setState(prevState => ({
                    ...prevState,
                    selected_user: propsPrecedenti.codiceUtente,
                }),
                    () => {
                        this.props.getStatistiche(this.state.selected_user);

                        if (this.props.codici_utente !== [])
                            if (this.props.codiceUtente === 'CODICEADMIN') this.props.getCodiciUtente();

                    }
                );
            }
        }
    }

    onSelectChange(newSelection) {
        if (newSelection !== this.state.select_sn) {
            
            this.setState(prevState => ({
                ...prevState,
                selected_user: newSelection,
            }),
                () => {
                    this.props.getStatistiche(this.state.selected_user);
                }
            );

        }
    }

    render() {
        const { classes, codiceUtente, codici_utente, tipologia, generali, anno } = this.props;


        return (
            <Paper className={classes.paperMain}>
                <Grid container spacing={3} >

                    <Grid item xs={12} sm={6}>

                        <Grid item xs={12} sm={12} >
                            <Grid container spacing={3} className={classes.formContainer}>


                                <SmallFormContainer labelText="Statistiche per">
                                    {codiceUtente === 'CODICEADMIN' ?
                                        <FormControl
                                            variant="outlined"
                                            size="small"
                                            className={classes.select}
                                        >
                                            <Select
                                                value={this.state.selected_user !== 'anonymous' ? this.state.selected_user : ''}
                                                onChange={e => this.onSelectChange(e.target.value)}
                                                autoWidth={true}
                                                MenuProps={{ classes: { paper: classes.menuPaper } }}
                                            >
                                                {codici_utente.map((item, index) => {

                                                    if (item === "CODICEADMIN")
                                                        return <MenuItem value={item} key={index}>Tutti gli utenti</MenuItem>;
                                                    else return <MenuItem value={item} key={index}>{item}</MenuItem>;

                                                })}
                                            </Select>
                                        </FormControl>
                                        :
                                        <TextField
                                            className={classes.textField}
                                            defaultValue={codiceUtente}
                                            InputProps={{ readOnly: true }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    }
                                </SmallFormContainer>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} >
                            <RotatedBarChart chartData={generali} />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid item xs={12} sm={12} >
                            <DoughnutChart chartData={tipologia} />
                        </Grid>
                        <Grid item xs={12} sm={12} >
                            <LineChart chartData={anno} />
                        </Grid>
                    </Grid>

                </Grid>
            </Paper>
        );

    }
}

StatisticheLicenzeCmp.propTypes = {
    tipologia: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    generali: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    anno: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getStatisticheRequestStatus: PropTypes.string.isRequired,

    codici_utente: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(StatisticheLicenzeCmp);